import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import { Modal } from "react-bootstrap";
import socket from "../../../Socket";
import storage from "../../../Storage";
import { decode, encode, sendNotfication, isPhoneValid1, isPhoneValid2, wait, Event } from "../../../Helper";
import C from "../../../Constant";
import ReactGA from "react-ga4";

class Register extends Component {
    constructor(props) {
        super(props);
        this._showing = false;
        this.state = {
            rule: false,
            show: this.props.show ? this.props.show : false,
            username: '',
            email: '',
            aff: storage.getKey('aff') ? storage.getKey('aff') : null,
            password: '',
            code: storage.getKey('ref_code') ? storage.getKey('ref_code') : null,
            reg: true,
            status: false,
            disabled: false,
            submitted: false,
            ruleChecked: false,
            regEffect: '',
            ruleEffect: '',
            effect: 'zoomIn'
        };
        this.switchMethod = this.switchMethod.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.openLogin = this.openLogin.bind(this);
    }

    componentWillMount() {
        this.setState({ code: storage.getKey('ref_code') });
    }

    componentDidMount() {
        ReactGA.event({
            category: 'User',
            action: 'Created an Account'
        });
        socket.on(C.REGISTER_USER, data => this.setRegister(decode(data)));
        this.checkRefCode();
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            if ((this.props.location.pathname === '/signup' || this.props.location.pathname === '/register') && !this.state.show) {
                this.checkRefCode();
            }
        }
    }

    setRegister = (data) => {
        let response = data;
        if (response.status === true) {

            // ✅ SEND EVENT TO GOOGLE TAG MANAGER
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: "sign_up",
                signup_method: "phone"
            });

            this.setState({ status: "Successfully Registered. Please Wait...", submitted: false });
            wait(1000).then(() => {
                storage.setKey('start_tour', 'true');
                socket.emit(C.LOGIN_USER, encode({
                    username: this.state.username,
                    password: this.state.password,
                    recaptcha: 'google'
                }));
            })
        }
        else {
            this.setState({ disabled: false, status: response.status, submitted: false });
            ReactGA.exception({
                description: 'An error ocurred',
                fatal: true
            });
        }
    };

    checkRefCode() {
        if (this.props.location.pathname === '/signup' || this.props.location.pathname === '/register') {
            this.handleShow();
        }
    };

    handleShow(e) {
        if (this._showing || this.state.show) return;
        this._showing = true;
        setTimeout(() => {
            this.setState({ show: true, effect: 'zoomIn' });
        }, 0);
    }

    handleClose() {
        this._showing = false;
        this.setState({ show: false, effect: 'zoomOut', submitted: false });
        if (this.props.location.pathname === '/signup' || this.props.location.pathname === '/register') {
            this.props.history.push('/');
        }
    }

    openLogin() {
        this.handleClose();
        Event.emit('open_login_modal');
    }

    switchMethod(e) {
        const target = e.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({ reg: value });
    }

    submitForm(e) {
        e.preventDefault();
        const { t } = this.props;
        this.setState({ submitted: true, disabled: true, status: t('please_wait') });

        const { username, email, password, reg, code, ruleChecked } = this.state;

        if (!(username && password)) {
            this.setState({ status: false, disabled: false });
            return;
        }

        if (username.length < 3) {
            this.setState({ status: t("please_enter_username_more_than_3_words"), disabled: false, });
            return;
        }

        if (reg) {
            if (!(isPhoneValid1(email) || isPhoneValid2(email))) {
                this.setState({ status: false, disabled: false });
                return sendNotfication(t('please_enter_valid_mobile_number'), 'warning', 'top-center');
            }
        }

        if (!ruleChecked) {
            this.setState({ status: "Make Sure About Rule Checkbox", disabled: false, });
            return;
        }

        socket.emit(C.REGISTER_USER, encode({
            username: username,
            password: password,
            country: 'kenya',
            email: email,
            method: reg,
            aff: code
        }));
    }

    ruler = e => {
        this.setState({ rule: true });
    }

    reg = e => {
        this.setState({ rule: false });
    }

    checkRule = e => {
        this.setState({ ruleChecked: !this.state.ruleChecked });
    }

    render() {
        const { submitted, email, username, password, disabled } = this.state;
        const { t } = this.props;
        return (
            <>
                {!this.state.show &&
                    <button className='register-btn' onClick={e => this.handleShow(e)}> {t('register')}</button>
                }
                <Modal
                    size="md"
                    centered={true}
                    show={this.state.show}
                    onHide={this.handleClose}
                    aria-labelledby="register-md-modal"
                    className={'auth-modal-custom animated ' + this.state.effect}
                >
                    <Modal.Header>
                        <img src="/assets/images/FASTA_FX.png" className={'auth-logo-large'} alt="Logo" />
                        <div className='auth-welcome-text'>
                            Registration
                        </div>
                        <button type="button" className="close" onClick={this.handleClose}>
                            <i className={'mdi mdi-close'} />
                        </button>
                    </Modal.Header>

                    {!this.state.rule ?
                        <Modal.Body className={"p-0 animated " + this.state.regEffect}>
                            <div className="auth-form-container">
                                <form className="auth-form" onSubmit={(e) => { this.submitForm(e) }}>
                                    <div className="auth-input-wrapper">
                                        <i className="mdi mdi-cellphone" />
                                        <input
                                            type="text"
                                            className="form-control auth-input-custom"
                                            placeholder="Mobile Number (07XX)"
                                            value={email}
                                            autoComplete="off"
                                            onChange={e => this.setState({ email: e.target.value })}
                                        />
                                        {submitted && !email &&
                                            <div className="help-block text-white small mt-1 ml-2">{t('mobile_is_required')}</div>
                                        }
                                    </div>

                                    <div className="auth-input-wrapper">
                                        <i className="mdi mdi-account-outline" />
                                        <input
                                            type="text"
                                            className="form-control auth-input-custom"
                                            placeholder="Username"
                                            value={username}
                                            autoComplete="off"
                                            onChange={e => this.setState({ username: e.target.value })}
                                        />
                                        {submitted && !username &&
                                            <div className="help-block text-white small mt-1 ml-2">{t('username_is_required')}</div>
                                        }
                                    </div>

                                    <div className="auth-input-wrapper">
                                        <i className="mdi mdi-lock-outline" />
                                        <input
                                            type="password"
                                            className="form-control auth-input-custom"
                                            placeholder="Password"
                                            value={password}
                                            autoComplete="off"
                                            onChange={e => this.setState({ password: e.target.value })}
                                        />
                                        {submitted && !password &&
                                            <div className="help-block text-white small mt-1 ml-2">{t('password_is_required')}</div>
                                        }
                                    </div>

                                    <div className="form-group mb-4 px-2">
                                        <div className="d-flex align-items-start gap-2 cursor-pointer" onClick={this.checkRule}>
                                            <div className={`mt-1 mr-2 d-flex align-items-center justify-content-center`} style={{
                                                width: '20px',
                                                height: '20px',
                                                borderRadius: '6px',
                                                border: '2px solid #f26722',
                                                background: this.state.ruleChecked ? '#f26722' : 'transparent',
                                                transition: 'all 0.2s',
                                                flexShrink: 0
                                            }}>
                                                {this.state.ruleChecked && <i className="mdi mdi-check text-white" style={{ fontSize: '14px' }} />}
                                            </div>
                                            <div className="font-weight-500" style={{ fontSize: '0.85rem', color: 'rgba(255,255,255,0.7)', lineHeight: '1.4' }}>
                                                {t('i_agree_with')} <span onClick={(e) => { e.stopPropagation(); this.ruler() }} className="cursor-pointer font-weight-700" style={{ color: '#f26722' }} >{t('user_agreement')}</span>, {t('and_confirm_that_i_am_at_least_18_years_old')}
                                            </div>
                                        </div>
                                    </div>

                                    <button type="submit" className="auth-btn-primary" disabled={disabled}>
                                        {disabled ? (
                                            <><i className="mdi mdi-loading mdi-spin mr-2" /> {t('please_wait')}...</>
                                        ) : (
                                            <><i className="mdi mdi-account-plus-outline mr-2" /> {t('register')}</>
                                        )}
                                    </button>

                                    <div className="text-center mt-3">
                                        <a href={'#'} onClick={(e) => { e.preventDefault(); this.openLogin(); }} className="auth-footer-link">
                                            Already have an account? Login
                                        </a>
                                    </div>

                                    {this.state.status &&
                                        <div className={'auth-status-alert'}>
                                            {this.state.status}
                                        </div>
                                    }
                                </form>
                            </div>
                        </Modal.Body>
                        :
                        <Modal.Body className={'p-0 animated ' + this.state.ruleEffect}>
                            <div className="auth-form-container">
                                <div className="p-3 mb-3" style={{
                                    maxHeight: '400px',
                                    overflowY: 'auto',
                                    background: 'rgba(0,0,0,0.2)',
                                    borderRadius: '16px',
                                    border: '1px solid rgba(255,255,255,0.05)',
                                    fontSize: '0.85rem',
                                    lineHeight: '1.6',
                                    color: 'rgba(255,255,255,0.6)'
                                }}>
                                    <h6 className="text-white font-weight-bold mb-3">User Agreement</h6>
                                    1. General
                                    <br />
                                    1.1. These User Agreement apply to the usage of games accessible through www.fastafx.com.
                                    <br />
                                    1.2. These User Agreement come into force as soon as you complete the registration process, which includes checking the box accepting these User Agreement and successfully creating an account.
                                    <br /><br />
                                    2. Binding Declarations
                                    <br />
                                    2.1. By agreeing to be bound by these User Agreement, you also agree to be bound by the our site Rules and Privacy Policy.
                                </div>
                                <div className="d-flex gap-3 mt-4">
                                    <button className="auth-btn-primary" onClick={this.reg}>I Agree</button>
                                    <button className="flex-1 px-4 py-3 bg-transparent border-0 text-white font-weight-bold" style={{ opacity: 0.6 }} onClick={this.handleClose}>Close</button>
                                </div>
                            </div>
                        </Modal.Body>
                    }
                </Modal>
            </>
        );
    }
}

export default withRouter(Register);